import { Fragment, type FC } from 'react';

import { Card } from '@mint-lib/tw-components';

import { OperationTypesEnum } from '../constants/singleFlow.js';
import type { LogicalGroupType } from '../types/singleFlow.js';
import EntityGroup from './EntityGroup.jsx';
import Separator from './Separator.jsx';

type Props = {
  items: LogicalGroupType;
};

const LogicalGroup: FC<Props> = ({ items }) => {
  return (
    <div className="flex items-center gap-x-2 gap-y-1">
      <Card variant="outlined" className="w-full">
        <div className="grid gap-3">
          {items.map((entityGroup, index) => {
            return (
              <Fragment key={JSON.stringify(entityGroup)}>
                {index === 0 ? null : (
                  <Separator variant={OperationTypesEnum.enum.and} />
                )}
                <EntityGroup items={entityGroup} />
              </Fragment>
            );
          })}
        </div>
      </Card>
    </div>
  );
};

export default LogicalGroup;
